import { Link } from 'react-router-dom';
import moment from 'moment';
import { MediaRenderer } from "@thirdweb-dev/react";
import dp from "../images/ls1.png";
import { AddReaction } from './PostInteractions/addReaction';
import { Mirror } from './PostInteractions/mirror';
import { Collect } from './PostInteractions/collect';
import {TailSpin} from 'react-loader-spinner';
import { useState,useEffect } from 'react';
import {lensClient} from "../client/LensClient";
import "./postsStyles.css";

export default function GetPosts({type,size}){

    const [posts, setAllPosts] = useState();
    useEffect(()=>{
        async function fetchPosts(){
            const result = await lensClient.explore.publications({
                orderBy: type,
                limit:size
            });
            setAllPosts(result.items);
        }
        fetchPosts();
    },[posts])

    return(
        <div className="content">
            {posts==null?<div className="spinner">
                <TailSpin height={150}></TailSpin>
                </div>:
            <>
            {posts.map((publication) =>(
                <>
                <div className="card">
                <div className="feedPostHeader">

                    {publication.by.metadata?.picture?.optimized?.uri==null?
                     <MediaRenderer src = {dp} className="feedPostProfilePicture" 
                     alt = {publication.by.handle?.fullHandle}/>
                    :
                    <MediaRenderer src = {publication.by.metadata?.picture?.optimized?.uri} className="feedPostProfilePicture"
                        alt = {publication.by.handle?.fullHandle}/>
                    }

                <div className="pos">posted by </div>
                <div className="name">
                    <Link to = {`/profile/${publication.by.id}`}>{publication.by.handle?.localName}</Link>
                </div>
                <div className="updated">
                    <p> about {moment(publication.createdAt).fromNow()}</p>
                </div>
                </div>
                <div className="feed">
                    <h4 className="feedTitle">{publication.metadata?.content}</h4>
                    {publication.metadata?.attachments==null?
                null:
                <>
                {publication.metadata?.attachments?.length==0?null:
                    <>{publication.metadata?.attachments[0]?.audio?<MediaRenderer src={publication.metadata?.attachments[0]?.audio?.optimized?.uri} className="feedImage"
                    alt={publication.metadata?.attachments?.content || ""}/>
                      :
                    <>
                    {publication.metadata?.attachments[0]?.video?
                    <MediaRenderer src={publication.metadata?.attachments[0]?.video?.optimized?.uri} className="feedImage"
                            alt={publication.metadata?.attachments?.content || ""}/>
                    :<MediaRenderer src={publication.metadata?.attachments[0]?.image?.optimized?.uri} className="feedImage"
                    alt={publication.metadata?.attachments?.content || ""}/>}
                    </>
                      }
                </>}</>} 
                </div>
                <div className="feedPostFooter">
                    <p> <AddReaction id = {[publication.id,]}/>{publication.stats?.upvotes}</p>
                    <p> <Collect id = {[publication.id,]}/>{publication.stats?.collects}</p>
                    <p> <Mirror id = {[publication.id,]}/>{publication.stats?.mirrors}</p>
                </div>
            </div>
            </>
            ))}
            </>}
        </div>
    );
}